import { memo } from 'react';
import { useCountUp, Props as ICountUpProps } from 'use-count-up';
import Typography, { ITypographyProps } from '../Typography';

export interface ITypographyWithCountUpProps extends ITypographyProps {
  value: number
  countUpProps?: ICountUpProps,
}

const TypographyWithCountUp = (props: ITypographyWithCountUpProps) => {
  const { value, countUpProps = {}, ...restTypographyProps } = props;
  const { value: countUpValue } = useCountUp({
    isCounting: true,
    duration: 1,
    end: value,
    ...countUpProps,
  });
  return (
    <Typography {...restTypographyProps}>
      {countUpValue}
    </Typography>
  );
};

export default memo(TypographyWithCountUp);
